import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/about.vue')
  },
  {
    path: '/layout',
    component: () => import('@/views/layout.vue'),
    children: [
      {
        path: 'home',
        component: () => import('@/views/home.vue')
      },
      {
        path: 'product',
        component: () => import('@/views/product.vue')
      },
      {
        path: 'product/detail/:id',
        component: () => import('@/views/productDetail.vue')
      },
      {
        path: 'solution',
        component: () => import('@/views/solution.vue')
      },
      {
        path: 'case',
        component: () => import('@/views/case.vue')
      },
      {
        path: 'new',
        component: () => import('@/views/new.vue')
      },
      {
        path: 'new/detail/:id',
        component: () => import('@/views/newDetail.vue')
      },
      {
        path: 'work',
        component: () => import('@/views/work.vue')
      },
      {
        path: 'contact',
        component: () => import('@/views/contact.vue')
      },
    ]
  },
]

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

export default router
